<template>
  <Layout style="height: 100%" class="main">
    <Sider
      hide-trigger
      collapsible
      :width="225"
      :collapsed-width="64"
      v-model="collapsed"
      class="left-sider"
      :style="{ overflow: 'hidden' }"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :active-name="$route.name"
        :collapsed="collapsed"
        @on-select="turnToPage"
        :menu-list="menuList"
      >
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <img v-show="!collapsed" :src="maxLogo" key="max-logo" />
          <img v-show="collapsed" :src="minLogo" key="min-logo" />
        </div>
        <div style="padding: 14px 24px; width: 100%" v-show="!collapsed">
          <Select
            v-model="menuName"
            filterable
            @on-change="toPage"
            placeholder="搜索页面"
            transfer
            filter-by-label
          >
            <Option
              :value="item.full_font_path"
              v-for="item in menuData"
              :key="item.full_font_path"
              :label="item.zh_title"
            ></Option>
          </Select>
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar
          :collapsed="collapsed"
          @on-coll-change="handleCollapsedChange"
        >
          <user :message-unread-count="unreadCount" :user-avatar="userAvatar" />
          <language
            v-if="$config.useI18n"
            @on-lang-change="langChange"
            style="margin-right: 10px"
            :lang="local"
          />
          <!-- <error-store v-if="$config.plugin['error-store'] && $config.plugin['error-store'].showInHeader" :has-read="hasReadErrorPage" :count="errorCount"></error-store> -->
          <fullscreen v-model="isFullscreen" style="margin-right: 10px" />
          <badge></badge>
          <order-badge></order-badge>
          <!-- <div
            style="margin-right: 20px;height:60px;display:flex;align-items: center;  justify-content: center;"
          >
            <div class="demo-badge">
              <Badge :count="10">
                <a @click="toAssistPlatform"> 协作平台</a>
              </Badge>
            </div>
          </div> -->
          <a
            v-if="
              $store.state.user &&
              $store.state.user.btnRole &&
              $store.state.user.btnRole[563]
            "
            style="margin-right: 20px"
            @click="toAssistBulletin"
            >{{ $t("bulletinBoard") }}</a
          >
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav
              :value="$route"
              @input="handleClick"
              :list="tagNavList"
              @on-close="handleCloseTag"
            />
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList">
              <router-view />
            </keep-alive>
            <iframe
              v-if="isIframe"
              src="https://monica.next.vnlin.com/viewer.html"
              frameborder="0"
              width="100%"
              height="100%"
              v-show="$route.path == '/operation_modules/dataBoard'"
            ></iframe>
            <ABackTop
              :height="100"
              :bottom="80"
              :right="50"
              container=".content-wrapper"
            ></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>
    <!-- <Modal
      :width="80"
      :mask-closable="false"
      v-model="bullentin"
      :title="bullentinCon.title"
      :footer-hide="true"
      class-name="bulletin-tit vertical-center-modal"
    >
      <div style="max-height:80vh;overflow-y:auto;">
        <div class="html-div" v-html="bullentinCon.content"></div>
        <Row v-if="bullentinCon.extends && bullentinCon.extends.length">
          <Col span="1">附件：</Col>
          <Col span="23">
            <div v-for="(ex, idx) in bullentinCon.extends" :key="'ex' + idx">
              <a class="extand-li" :href="$globalUrl + ex.src">
                {{ ex.name }}
              </a>
            </div>
          </Col>
        </Row>
        <div style="color:#888">发布日期：{{ bullentinCon.create_time }}</div>
      </div>
    </Modal> -->
    <Modal
      :mask-closable="false"
      v-model="bullentin"
      :title="bullentinCon.title"
      :footer-hide="true"
      width="750"
      class-name="bulletin-tit vertical-center-modal"
    >
      <div style="max-height: 80vh; overflow-y: auto">
        <div class="html-div" v-html="bullentinCon.content"></div>
        <Row
          style="font-family: '仿宋' !important"
          v-if="bullentinCon.extends && bullentinCon.extends.length"
        >
          <Col span="2">附件：</Col>
          <Col span="22">
            <div v-for="(ex, idx) in bullentinCon.extends" :key="'ex' + idx">
              <a class="extand-li" :href="$globalUrl + ex.src">
                {{ ex.name }}
              </a>
            </div>
          </Col>
        </Row>
      </div>
      <div style="display: flex">
        <div style="color: #888; flex: 1">
          <span style="margin-right: 30px"
            >{{ $t("publisher") }}：{{ bullentinCon.operate_name }}</span
          >{{ $t("bulletinTime") }}：{{ bullentinCon.create_time }}
        </div>
        <Button
          @click="readBulletin(bullentinCon.id)"
          v-if="!bullentinCon.isRead"
          type="success"
          >已确定阅读</Button
        >
      </div>
      <div
        v-if="bullentinCons.length > 1"
        style="
          text-align: center;
          font-family: '仿宋' !important;
          font-size: 20px !important;
        "
      >
        <Page
          :total="bullentinCons.length * 10"
          :current.sync="bullentinConIndex"
          size="small"
          @on-change="bullentinConIndex = $event"
        />
      </div>
    </Modal>
  </Layout>
</template>
<script>
import SideMenu from "./components/side-menu";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import badge from "./components/badge";
import orderBadge from "./components/order-badge";
import ABackTop from "./components/a-back-top";
import Fullscreen from "./components/fullscreen";
import Language from "./components/language";
import ErrorStore from "./components/error-store";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { getNewTagList, routeEqual } from "@/libs/util";
import routers from "@/router/routers";
import minLogo from "@/assets/images/logo.png";
import maxLogo from "@/assets/images/logo.png";
import "./main.less";
import { getMenu } from "@/api/user";
import { pushBulletin, readBulletin } from "@/api/operation_modules/bulletin";
import { home } from "@/api/public.js";
import { tableApis } from "@/libs/api.request";
export default {
  inject: ["reload"],
  name: "Main",
  components: {
    SideMenu,
    HeaderBar,
    Language,
    TagsNav,
    Fullscreen,
    ErrorStore,
    User,
    ABackTop,
    badge,
    orderBadge,
  },
  data() {
    return {
      collapsed: false,
      minLogo,
      maxLogo,
      isFullscreen: false,
      menuName: "",
      menuData: [],
      bullentin: false,
      bullentinConIndex: 0,
      bullentinCons: [],
      isUpload: false,
      isIframe: false,
    };
  },
  computed: {
    ...mapGetters(["errorCount"]),
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    tagRouter() {
      return this.$store.state.app.tagRouter;
    },
    userAvatar() {
      return this.$store.state.user.avatarImgPath;
    },
    cacheList() {
      const list = [
        "ParentView",
        ...(this.tagNavList.length
          ? this.tagNavList
              .filter((item) => !(item.meta && item.meta.notCache))
              .map((item) => item.name)
          : []),
      ];
      return list;
    },
    menuList() {
      return this.$store.getters.menuList;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    },
    bullentinCon() {
      return this.bullentinCons[this.bullentinConIndex - 1] || {};
    },
  },

  methods: {
    async getVersion() {
      let res = await home();
      let version = res.data.match(/js\/app\.[^js]*/g);
      if (version[0]) {
        version = version[0].match(/\.+(.+)\./)[1];
      }
      console.log(version);
      return version;
    },
    async saveVersion() {
      let version = await this.getVersion();
      localStorage.setItem("pageVersion", version);
    },
    async handleUpdate() {
      if (this.isUpload) return;
      let version = await this.getVersion();
      let oldVersion = localStorage.getItem("pageVersion");
      if (!oldVersion) {
        localStorage.setItem("pageVersion", version);
        return;
      }
      if (oldVersion !== version) {
        this.isUpload = true;
        this.$Modal.confirm({
          title: this.$t("versionUpdate"),
          content: this.$t("whetherUpdatePage"),
          onOk() {
            localStorage.setItem("pageVersion", version);
            location.reload();
          },
          onCancel() {
            localStorage.setItem("pageVersion", version);
          },
        });
      }
    },
    readBulletin() {
      this.bullentinCon.isRead = true;
      readBulletin(this.bullentinCon.id);
      this.setBullentinCon(this.bullentinConIndex + 1);
    },
    setBullentinCon(num) {
      let index =
        num > this.bullentinCons.length ? this.bullentinCons.length : num;
      let tempIndex = -1;
      this.bullentinCons.find((item, index) => {
        if (!item.isRead) {
          tempIndex = index + 1;
          return true;
        }
      });
      if (tempIndex === -1) {
        return (this.bullentin = false);
      } else if (this.bullentinCons[index - 1].isRead) {
        this.bullentinConIndex = tempIndex;
      } else this.bullentinConIndex = index;
    },
    toPage(item) {
      let data = this.menuData;
      this.menuData = [];
      this.$router.push(item);
      this.$nextTick(() => {
        this.menuName = "";
        this.menuData = data;
      });
    },
    toAssistPlatform() {
      this.$router.push({ name: "assistPlatform" });
    },
    toAssistBulletin() {
      this.$router.push({ name: "bulletinBoard" });
    },
    ...mapMutations([
      "setBreadCrumb",
      "setTagNavList",
      "addTag",
      "setLocal",
      "setHomeRoute",
      "closeTag",
    ]),
    ...mapActions(["handleLogin"]),
    turnToPage(route) {
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf("isTurnByHref_") > -1) {
        window.open(name.split("_")[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query,
      });
    },

    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      if (type !== "others") {
        if (type === "all") {
          this.turnToPage(this.$config.homeName);
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route);
          }
        }
      } else {
        this.turnToPage(route);
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
    langChange(name) {
      this.$i18n.locale = name;
      this.setLocal({ lang: name, that: this, isReload: true });
    },
  },
  watch: {
    $route(newRoute) {
      const { name, query, params, meta } = newRoute;
      if (name === "dataBoard") this.isIframe = true;
      this.addTag({
        route: { name, query, params, meta },
        type: "push",
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    },
  },
  mounted() {
    if (this.$route.name === "dataBoard") this.isIframe = true;
    setTimeout(() => {
      process.env.NODE_ENV === "development" && console.table(tableApis);
    }, 1000);
    // this.saveVersion()
    // setInterval(() => {
    // 	this.handleUpdate()
    // },10000);
    getMenu().then((res) => {
      this.menuData = res.data.payload;
      pushBulletin().then((res) => {
        if (res.data.payload) {
          this.bullentin = true;
          this.bullentinCons = res.data.payload;
          this.setBullentinCon(1);
        } else {
          this.bullentin = false;
        }
      });
    });
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList();
    this.setHomeRoute(routers);
    const { name, params, query, meta } = this.$route;
    this.addTag({
      route: { name, params, query, meta },
    });
    this.setBreadCrumb(this.$route);
    // 设置初始语言
    this.setLocal({ lang: this.$i18n.locale, that: this });
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find((item) => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName,
      });
    }
    // 获取未读消息条数
    // this.getUnreadMessageCount()
  },
};
</script>
<style lang="less">
.demo-badge {
  // width: 42px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  align-items: center;
  justify-content: center;
}
</style>
